import Main from "@/views/index/Main.vue";

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
  path: "/login",
  name: "login",
  meta: {
    title: "登录-行业学考平台",
  },
  component: () => import("@/views/index/login.vue"),
};

export const registRouter = {
  path: "/regist",
  name: "regist",
  meta: {
    title: "注册-美达中国Java快速开发平台",
  },
  component: () => import("@/views/index/regist.vue"),
};

export const registResult = {
  path: "/regist-result",
  name: "regist-result",
  meta: {
    title: "注册结果-美达中国Java快速开发平台",
  },
  component: () => import("@/views/index/regist-result.vue"),
};

export const relateRouter = {
  path: "/relate",
  name: "relate",
  meta: {
    title: "绑定账号-美达中国Java快速开发平台",
  },
  component: () => import("@/views/index/relate.vue"),
};

// export const page404 = {
//     path: '/*',
//     name: 'error-404',
//     meta: {
//         title: '404-页面不存在'
//     },
//     component: () => import('@/views/error-page/404.vue')
// };

export const page403 = {
  path: "/403",
  meta: {
    title: "403-权限不足",
  },
  name: "error-403",
  component: () => import("@/views/error-page/403.vue"),
};

export const page500 = {
  path: "/500",
  meta: {
    title: "500-服务端错误",
  },
  name: "error-500",
  component: () => import("@/views/error-page/500.vue"),
};

export const locking = {
  path: "/locking",
  name: "locking",
  component: () =>
    import("@/views/main-components/lockscreen/components/locking-page.vue"),
};

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: "/",
  name: "otherRouter",
  redirect: "/home",
  component: Main,
  children: [
    {
      path: "home",
      title: { i18n: "home" },
      name: "home_index",
      component: () => import("@/views/home/home3.vue"),
    },
    {
      path: "ownspace",
      title: "个人中心",
      name: "ownspace_index",
      component: () => import("@/views/own-space/own-space.vue"),
    },
    {
      path: "change-pass",
      title: "修改密码",
      name: "change_pass",
      component: () => import("@/views/change-pass/change-pass.vue"),
    },
    {
      path: "message",
      title: "消息中心",
      name: "message_index",
      component: () => import("@/views/message/message.vue"),
    },
    {
      path: "add",
      title: "添加",
      name: "add",
      component: () => import("@/views/xboot-vue-template/new-window/add.vue"),
    },
    {
      path: "edit",
      title: "编辑",
      name: "edit",
      component: () => import("@/views/xboot-vue-template/new-window/edit.vue"),
    },
    {
      path: "add-edit-message",
      title: "消息详情",
      name: "add_edit_message",
      component: () =>
        import("@/views/sys/message-manage/addOrEditMessage.vue"),
    },
    {
      path: "message-send-detail",
      title: "消息发送详情",
      name: "message_send_detail",
      component: () =>
        import("@/views/sys/message-manage/messageSendDetail.vue"),
    },
    {
      path: "add-edit-news",
      title: "新闻详情",
      name: "add_edit_news",
      component: () => import("@/views/sys/news-manage/addOrEditNews.vue"),
    },
    {
      path: "add_edit_credit_news",
      title: "信用详情",
      name: "add_edit_credit_news",
      component: () =>
        import("@/views/sys/creditNewsManage/addOrEditCreditNews.vue"),
    },
    {
      path: "add-course",
      title: "添加课程",
      name: "add_course",
      component: () => import("@/views/bus/course-manage/course.vue"),
    },
    {
      path: "add-course",
      title: "添加课程",
      name: "add_course",
      component: () => import("@/views/bus/course-manage/course.vue"),
    },
    {
      path: "thesisAudit",
      title: "论文审核详情",
      name: "thesisAudit",
      component: () => import("@/views/thesis/thesisAudit.vue"),
    },
    {
      path: "paperInterviewDetail",
      title: "面试详情",
      name: "paperInterviewDetail",
      component: () => import("@/views/thesis/paperInterviewDetail.vue"),
    },
    {
      path: "userDetail",
      title: "员工详情",
      name: "userDetail",
      component: () =>
        import("@/views/sys/organizationalStructure/staffSetting.vue"),
    },
    {
      path: "admin/roleEdit",
      title: "角色设置",
      name: "roleEdit",
      component: () =>
        import("@/views/sys/organizationalStructure/rolePowerEdit.vue"),
    },

    //新增
    {
      path: "examinationEdit",
      title: "添加试题到试卷",
      name: "examinationEdit",
      component: () =>
        import("@/views/examination-management/examinationEdit.vue"),
    },
    {
      path: "questionEdit",
      title: "添加试题",
      name: "questionEdit",
      component: () => import("@/views/question/questionEdit.vue"),
    },
    {
      path: "/admin/examination-list/examDetail",
      title: "考试详情",
      name: "examEdit",
      component: () => import("@/views/examination-management/examDetail.vue"),
    },
    {
      name: "applyEdit",
      title: "报名编辑",
      path: "/admin/applyList/applyEdit",
      component: () => import("@/views/apply/applyEdit.vue"),
    },
    {
      name: "recordList",
      title: "考试记录",
      path: "/admin/examination-list/recordList",
      component: () => import("@/views/examination-management/recordList.vue"),
    },
    {
      name: "recordEdit",
      title: "批改试卷",
      path: "/admin/examination-list/recordEdit",
      component: () => import("@/views/examination-management/recordEdit.vue"),
    },
    {
      name: "recordReports",
      title: "考试报告",
      path: "/admin/examination-list/recordReports",
      component: () =>
        import("@/views/examination-management/recordReport.vue"),
    },
    {
      name: "paperAnalysis",
      title: "考试分析",
      path: "/admin/examination-list/paperAnalysis",
      component: () =>
        import("@/views/examination-management/paperAnalysis.vue"),
    },
    {
      name: "thesisAudit",
      title: "审核论文",
      path: "/admin/thesisAuditList/thesisAudit",
      component: () => import("@/views/paper/thesisAudit.vue"),
    },
    {
      name: "paperInterviewDetail",
      title: "审核论文",
      path: "/admin/paperInterviewList/paperInterviewDetail",
      component: () => import("@/views/paper/paperInterviewDetail.vue"),
    },
    {
      name: "thesisUpload",
      title: "上传论文",
      path: "/admin/thesisList/thesisUpload",
      component: () => import("@/views/paper/thesisUpload.vue"),
    },

    {
      name: "monitorList",
      title: "视频监控",
      path: "/admin/monitorList",
      component: () => import("@/views/antiCheating/monitorList.vue"),
    },
    {
      name: "appMonitorList",
      title: "app视频监控",
      path: "/admin/appMonitorList",
      component: () => import("@/views/antiCheating/appMonitorList.vue"),
    },
    {
      name: "studentOnApply",
      title: "报名管理",
      path: "/admin/studentOnApply",
      component: () => import("@/views/apply/studentOnApply.vue"),
    },
    {
      name: "learnAnalysis",
      title: "学习数据分析",
      path: "/admin/learnAnalysis",
      component: () => import("@/views/bus/course-manage/learnAnalysis.vue"),
    },
    {
      name: "manualFaceCheck",
      title: "人脸手动审核",
      path: "/manualFaceCheck",
      component: () =>
        import("@/views/examination-management/manualFaceCheck.vue"),
    },
    {
      name: "courseStudentManage",
      title: "人脸手动审核",
      path: "/course/courseStudentManage",
      component: () =>
        import("@/views/bus/course-manage/courseStudentManage.vue"),
    },
    {
      name: "studentDetail",
      title: "考生数据分析",
      path: "/apply/studentDetail",
      component: () => import("@/views/apply/studentDetail.vue"),
    },
  ],
};

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
// export const appRouter = [
//     {
//         path: '/form',
//         icon: 'ios-gear',
//         name: 'sys',
//         title: '系统管理',
//         component: Main,
//         children: [
//             { path: 'user-manage', title: '用户管理', name: 'user-manage', icon: 'android-person', component: () => import('@/views/sys/user-manage/userManage') },
//             { path: 'role-manage', title: '角色管理', name: 'role-manage', icon: 'android-contacts', component: () => import('@/views/sys/role-manage/roleManage.vue') },
//             { path: 'menu-manage', title: '菜单管理', name: 'menu-manage', icon: 'navicon-round', component: () => import('@/views/sys/menu-manage/menuManage.vue') },
//             { path: 'log-manage', title: '日志管理', name: 'log-manage', icon: 'android-list', component: () => import('@/views/sys/log-manage/logManage.vue') }
//         ]
//     }
// ];

export const appRouter = [];

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  loginRouter,
  registRouter,
  registResult,
  relateRouter,
  otherRouter,
  locking,
  ...appRouter,
  page500,
  page403,
];
